import React from "react"
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai"
import BuildingElement from "../buildingElement"
import ResourceElement from "../resourceElement"

/**
 * Paso 1 — Datos de la Cirugía
 * Hospital, quirófano, fecha, hora de inicio y duración
 */

const DURACIONES = [
    { label: '30 min', value: 30  },
    { label: '1 hora', value: 60  },
    { label: '1½ h',  value: 90  },
    { label: '2 h',   value: 120 },
    { label: '2½ h',  value: 150 },
    { label: '3 h',   value: 180 },
    { label: '3½ h',  value: 210 },
    { label: '4 h',   value: 240 },
    { label: '4½ h',  value: 270 },
    { label: '5 h',   value: 300 },
    { label: '5½ h',  value: 330 },
    { label: '6 h',   value: 360 },
]

const StepCirugia = ({
    // Hospital
    buildHadError,
    buildingList,
    buildingSelected, setBuildingSelected,
    clicBuildingSelect,
    mostrarOcultarBuilding,
    // Quirófano
    resourceHadError,
    resourcesList,
    resourcesSelected, setResourcesSelected,
    clicResourcesSelect,
    mostrarOcultarResources,
    // Fecha
    fechaSeleccionadaHadError,
    fecha_seleccionada,
    today,
    mostrarMensajeFecha,
    onChangeDate,
    // Hora inicial
    horaInicialHadError,
    horaInicialSelected,
    clicHoraInicialSelected,
    mostrarOcultarHoraInicial,
    horasInicialesDisponibles,
    seleccionarHoraInicial,
    // Duración → calcula hora final automáticamente
    horaFinalHadError,
    horaFinalSelected,
    duracionSeleccionada,
    setDuracionSeleccionada,
}) => (
    <div className="rq-panel">

        {/* Hospital */}
        <div className={buildHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorBuilding">
            <label className="rq-label">¿Dónde quiere reservar?<span className="rq-required">*</span></label>
            <div className="rq-content">
                <div id="buildingSelected" className="rq-select-btn" onClick={mostrarOcultarBuilding}>
                    <span>{buildingSelected}</span>
                    {clicBuildingSelect ? <AiFillCaretUp/> : <AiFillCaretDown/>}
                </div>
                {clicBuildingSelect && (
                    <div className="rq-dropdown">
                        {buildingList.map(build => (
                            <BuildingElement
                                key={build.id}
                                build={build}
                                buildingSelected={buildingSelected}
                                setBuildingSelected={setBuildingSelected}
                                mostrarOcultarBuilding={mostrarOcultarBuilding}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>

        {/* Quirófano */}
        <div className={resourceHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorResources">
            <label className="rq-label">En el quirófano<span className="rq-required">*</span></label>
            <div className="rq-content">
                <div id="resourcesSelected" className="rq-select-btn" onClick={mostrarOcultarResources}>
                    <span>{resourcesSelected}</span>
                    {clicResourcesSelect ? <AiFillCaretUp/> : <AiFillCaretDown/>}
                </div>
                {clicResourcesSelect && (
                    <div className="rq-dropdown">
                        {resourcesList.map(resource => (
                            <ResourceElement
                                key={resource.id}
                                resource={resource}
                                resourcesSelected={resourcesSelected}
                                setResourcesSelected={setResourcesSelected}
                                mostrarOcultarResources={mostrarOcultarResources}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>

        {/* Fecha */}
        <div className={fechaSeleccionadaHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorFecha">
            <label className="rq-label">Día de la cirugía<span className="rq-required">*</span></label>
            <div className="rq-content">
                {mostrarMensajeFecha && <span className="rq-hint">Selecciona la fecha de cirugía</span>}
                <input
                    type="date"
                    id="fecha_seleccionada"
                    name="fecha_seleccionada"
                    className="rq-input"
                    value={fecha_seleccionada}
                    min={today}
                    onChange={onChangeDate}
                />
            </div>
        </div>

        {/* Hora inicial */}
        <div className={horaInicialHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorHoraInicial">
            <label className="rq-label">Hora de inicio<span className="rq-required">*</span></label>
            <div className="rq-content">
                <div id="horaInicialSelected" className="rq-select-btn" onClick={mostrarOcultarHoraInicial}>
                    <span>{horaInicialSelected}</span>
                    {clicHoraInicialSelected ? <AiFillCaretUp/> : <AiFillCaretDown/>}
                </div>
                {clicHoraInicialSelected && (
                    <div className="rq-time-grid">
                        {horasInicialesDisponibles.map(hora => (
                            <div
                                key={hora.hora + ":" + hora.minutos}
                                className="rq-time-chip"
                                onClick={seleccionarHoraInicial(hora.hora + ":" + hora.minutos)}
                            >
                                {hora.hora}:{hora.minutos}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>

        {/* Duración → calcula hora final automáticamente */}
        <div className={horaFinalHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorDuracion">
            <label className="rq-label">Duración de la cirugía<span className="rq-required">*</span></label>
            <div className="rq-content">
                <div className="rq-duration-grid">
                    {DURACIONES.map(d => (
                        <div
                            key={d.value}
                            className={`rq-duration-chip${duracionSeleccionada === d.value ? ' rq-duration-chip--selected' : ''}`}
                            onClick={() => setDuracionSeleccionada(d.value)}
                        >
                            {d.label}
                        </div>
                    ))}
                </div>
                {horaFinalSelected && !horaFinalSelected.includes('Seleccione') && (
                    <div className="rq-hora-final-result">
                        <span className="rq-hora-final-label">Hora de finalización calculada</span>
                        <span className="rq-hora-final-value">{horaFinalSelected}</span>
                    </div>
                )}
            </div>
        </div>

    </div>
)

export default StepCirugia